// extracted by mini-css-extract-plugin
export default {"mainCont":"MnpListItem_mainCont__Q1F0j"};